module.exports = __webpack_public_path__ + "static/media/fog.0e80ca2f.svg";